export default __webpack_public_path__ + "static/media/Alvazar's Vest.2c3ab8c4.jpg";